"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=FidjApiAppsDetailsResponse.js.map